<script lang="ts">
  import {loadTranslations, changeLocale} from '$lib/i18n';
  import type {LayoutData} from './$types';
  import {page} from "$app/stores";
  import {userService} from "$lib/services/user.service";
  import {balances, OverlayLoaderShow, user, userReducer} from "$lib/stores";
  import {toasts} from "$lib/stores/toastStores";
  import {isConnected, messages} from "$lib/stores/websocket";
  import { browser } from "$app/environment";
  import { onMount } from 'svelte';

  // Use the traditional export let pattern for SvelteKit layouts
  export let data: LayoutData;

  let socket: any;

  // Initialize on mount
  onMount(async () => {
    // Change locale based on data
    changeLocale(data?.lang || 'en');
    
    // Load translations
    await loadTranslations(data?.lang || 'en', window.fetch);
    
    // Subscribe to page changes
    const unsubscribe = page.subscribe(value => {
      console.log(value);
      if (value.url.searchParams.get('r')) {
        localStorage.setItem('forza_referral', String(value.url.searchParams.get('r')));
      }
      if (value.url.searchParams.get('clickid')) {
        localStorage.setItem('f_ckid', String(value.url.searchParams.get('clickid')));
      }

      if (value.data?.user) {
        userReducer(value.data?.user);
        userService.getBalances().then((response: any) => {
          if (response) {
            return response.data;
          }
          toasts.send('Failed to fetch balances', 'error');
          throw new Error('Failed to fetch balances');
        }).then(data => {
          balances.set(data.data);
        }).catch(err => {
          console.error(err);
        });
      }
    });
    
    // Initialize click tracking
    initClick();
    
    // Set overlay loader to false
    OverlayLoaderShow.set(false);
    
    // Clean up subscription on component destruction
    return () => {
      unsubscribe();
    };
  });

  function initClick() {
    setTimeout(() => {
      if (!localStorage.getItem('ckt')) {
        userService.initClick({
          referralCode: localStorage.getItem('forza_referral'),
          token: uuid4(),
        }).then(() => {
          console.log('Click initialized');
        });
      }
    }, 3000);
  }

  function uuid4() {
    let array = new Uint8Array(16);
    crypto.getRandomValues(array);

    // Manipulate the 9th byte
    array[8] &= 0b00111111; // Clear the first two bits
    array[8] |= 0b10000000; // Set the first two bits to 10

    // Manipulate the 7th byte
    array[6] &= 0b00001111; // Clear the first four bits
    array[6] |= 0b01000000; // Set the first four bits to 0100

    const pattern = "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX";
    let idx = 0;

    return pattern.replace(
      /XX/g,
      () => array[idx++].toString(16).padStart(2, "0"), // padStart ensures a leading zero, if needed
    );
  }
</script>

<slot />